import { render, staticRenderFns } from "./DocumentRuleCondition.vue?vue&type=template&id=ae0796b4&scoped=true"
import script from "./DocumentRuleCondition.vue?vue&type=script&lang=js"
export * from "./DocumentRuleCondition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0796b4",
  null
  
)

export default component.exports